import * as betgalaxy from './Featured.styles.betgalaxy';
import * as betprofessor from './Featured.styles.betprofessor';
import * as betroyale from './Featured.styles.betroyale';
import * as fiestabet from './Featured.styles.fiestabet';
import * as puntcity from './Featured.styles.puntcity';
import * as puntgenie from './Featured.styles.puntgenie';
import * as questbet from './Featured.styles.questbet';
import * as sterlingparker from './Featured.styles.sterlingparker';
import * as vikingbet from './Featured.styles.vikingbet';
import * as volcanobet from './Featured.styles.volcanobet';
import * as wellbet from './Featured.styles.wellbet';
import * as goldenrush from './Featured.styles.goldenrush';
import * as juicybet from './Featured.styles.juicybet';
import * as forsport from './Featured.styles.forsport';
import * as junglebet from './Featured.styles.junglebet';
import * as sugarcastle from './Featured.styles.sugarcastle';
import * as oldgill from './Featured.styles.oldgill';
import * as buffalobet from './Featured.styles.buffalobet';
import * as titanbet from './Featured.styles.titanbet';
import * as bet777 from './Featured.styles.bet777';
import * as goldenbet888 from './Featured.styles.goldenbet888';
import * as slambet from './Featured.styles.slambet';
import * as gigabet from './Featured.styles.gigabet';
import * as betstride from './Featured.styles.betstride';
import * as chromabet from './Featured.styles.chromabet';
import * as templebet from './Featured.styles.templebet';
import * as hyperbet from './Featured.styles.hyperbet';
import * as bet575 from './Featured.styles.bet575';
import * as epicodds from './Featured.styles.epicodds';
import * as pyramidbet from './Featured.styles.pyramidbet';
import * as magnumbet from './Featured.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  bet777,
  goldenbet888,
  slambet,
  gigabet,
  betstride,
  chromabet,
  templebet,
  hyperbet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
